/**
 * Fly-to-cart animation.
 * Clones a product image and animates a floating copy along an arc to the
 * header cart badge (.cart-count), then "bumps" the badge.
 *
 * Purely visual and fully defensive: if anything is missing or unsupported,
 * it silently no-ops so add-to-cart is never affected.
 *
 * @param {HTMLImageElement|null} sourceImg The product image to fly from.
 */
export default function flyToCart(sourceImg) {
  try {
    if (!sourceImg) return;

    var target = document.querySelector(".cart-count");
    if (!target) return;

    // Respect users who prefer reduced motion — still bump the count.
    if (
      window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches
    ) {
      bumpCart(target);
      return;
    }

    var imgRect = sourceImg.getBoundingClientRect();
    var targetRect = target.getBoundingClientRect();
    if (!imgRect.width || !imgRect.height) return;

    var clone = sourceImg.cloneNode(true);
    clone.removeAttribute("id");
    clone.className = "fly-to-cart-clone";
    clone.style.left = imgRect.left + "px";
    clone.style.top = imgRect.top + "px";
    clone.style.width = imgRect.width + "px";
    clone.style.height = imgRect.height + "px";
    document.body.appendChild(clone);

    var dx =
      targetRect.left + targetRect.width / 2 - (imgRect.left + imgRect.width / 2);
    var dy =
      targetRect.top + targetRect.height / 2 - (imgRect.top + imgRect.height / 2);

    // Guard: older browsers without the Web Animations API just clean up.
    if (typeof clone.animate !== "function") {
      clone.remove();
      bumpCart(target);
      return;
    }

    var animation = clone.animate(
      [
        { transform: "translate(0, 0) scale(1)", opacity: 0.9 },
        {
          transform:
            "translate(" + dx * 0.5 + "px, " + (dy * 0.5 - 60) + "px) scale(0.6)",
          opacity: 0.85,
          offset: 0.5
        },
        {
          transform: "translate(" + dx + "px, " + dy + "px) scale(0.1)",
          opacity: 0.3
        }
      ],
      { duration: 700, easing: "cubic-bezier(.55,.06,.3,1)" }
    );

    var cleanup = function() {
      if (clone.parentNode) clone.parentNode.removeChild(clone);
      bumpCart(target);
    };

    animation.onfinish = cleanup;
    // Safety net in case onfinish never fires.
    setTimeout(function() {
      if (clone.parentNode) cleanup();
    }, 1000);
  } catch (e) {
    // Never let a visual effect break add-to-cart.
  }
}

function bumpCart(target) {
  if (!target) return;
  target.classList.remove("cart-bump");
  // Force reflow so the animation can restart on rapid clicks.
  void target.offsetWidth;
  target.classList.add("cart-bump");
  setTimeout(function() {
    target.classList.remove("cart-bump");
  }, 450);
}
